import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'router/routes';
import { useUserData } from 'context/UserDataProvider';
import type { UserData } from 'hooks/useGetUserData';


/**
 * Returns the current user's subscription info, or null if not available.
 */
export function useUserSubscription() {
    const { userData: userDataFromContext } = useUserData();
    const myUserData = userDataFromContext as UserData | null;
    return myUserData?.db_subscription_information ?? null;
}

/**
 * Redirects to MY_AGENT if user has no subscription.
 * Uses useUserSubscription to check subscription_info.
 */
export function useRequireSubscription() {
    const navigate = useNavigate();
    const subscription = useUserSubscription();
    useEffect(() => {
        if (subscription == null) {
            navigate(PATHS.MY_AGENT, { replace: true });
        }
    }, [subscription, navigate]);
}
